// Fordításkezelő segédfunkció a meglévő jobverse-en-strings.json és beépített szótár alapján

const BUILTIN_EN_TRANSLATIONS: Record<string, string> = {
  // Lépések, fejlécek
  'JOBVERSE Látogatói regisztráció': 'JOBVERSE Visitor Registration',
  'Töltsd ki az alábbi mezőket a regisztrációhoz.': 'Please fill in the fields below to register.',
  'Belépési adatok': 'Login data',
  'Személyes adatok': 'Personal data',
  'Szakmai adatok': 'Professional data',
  'Szakmai Adatok': 'Professional data',
  'SZAKMAI ADATOK': 'Professional data',
  'Regisztrációs lépések': 'Registration steps',
  'A részvétel INGYENES, regisztrálj, és jelentkezz aktuális rendezvényünkre!': 'Taking part in the event is FREE, you only need to register!',
  'A kötelező mezőket * karakter jelöli.': 'Required fields are marked with an * character.',
  'A *-gal jelölt mezők kitöltése kötelező.': 'Required fields are marked with an * character.',
  'Vissza': 'Back',
  'Tovább': 'Next',
  'REGISZTRÁCIÓ BEFEJEZÉSE': 'Register',
  'Regisztráció...': 'Registering...',

  // Step 1: Belépési adatok
  'E-mail': 'E-mail address',
  'pelda@email.hu': 'example@email.com',
  'Új jelszó': 'New password',
  'Új jelszó*': 'New password*',
  'Min. 8 kar., nagybetű és szám': 'Min. 8 chars, uppercase & number',
  'Jelszó újra': 'Enter password again',
  'Jelszó újra*': 'Enter password again*',
  'Jelszó ismétlése': 'Enter password again',
  'Jelszó elrejtése': 'Hide password',
  'Jelszó megjelenítése': 'Show password',
  'Kijelentem, hogy az ': 'I declare that I read, understood and accept the ',
  'Adatvédelmi tájékoztató': 'Privacy Policy',
  't elolvastam, megértettem, elfogadom, és hozzájárulok, hogy az állásértesítőm létrehozásához Szervező az általam megadott adatokat felhasználja.': ' and I agree that the Organizer will use the data I provided to create my job advertisement.',

  // Step 1: Validáció
  'Érvényes e-mail cím megadása kötelező.': 'Valid e-mail address is required.',
  'Jelszó megadása kötelező.': 'Password is required.',
  'Min. 8 karakter, tartalmazzon nagybetűt és számot.': 'Min. 8 characters, must contain an uppercase letter and a number.',
  'Jelszó megerősítése kötelező.': 'Password confirmation is required.',
  'A két jelszó nem egyezik.': 'Passwords do not match.',
  'Az Adatvédelmi tájékoztató elfogadása kötelező.': 'You must accept the Privacy Policy.',
  'Kérjük, töltsd ki a reCAPTCHA ellenőrzést.': 'Please complete the reCAPTCHA verification.',

  // Step 2: Személyes adatok
  'Vezetéknév': 'Last name',
  'Vezetéknév*': 'Last name*',
  'Keresztnév': 'First name',
  'Keresztnév*': 'First name*',
  'Telefonszám': 'Mobile phone number',
  'Telefonszám*': 'Mobile phone number*',
  'Ország hívószáma': 'Country calling code',
  'Születési év': 'Birth year',
  'Születési év*': 'Birth year*',
  'pl. 1998': 'e.g. 1998',
  'Nem': 'Gender',
  'Nem*': 'Gender*',
  'Férfi': 'Male',
  'Nő': 'Female',
  'Nem szeretnék válaszolni': 'Rather not say',
  'Nem szeretném megadni': 'Rather not say',
  'Milyen nyelven szeretnéd megkapni az állásbörzéről az információkat?': 'In which language would you like to receive information about the job fair?',
  'Nyelvi preferencia': 'Language preference',
  'Magyar': 'Hungarian',
  'Angol': 'English',
  'magyar': 'hungarian',
  'angol': 'english',

  // Step 2: Validáció
  'Vezetéknév megadása kötelező.': 'Last name is required.',
  'Keresztnév megadása kötelező.': 'First name is required.',
  'Telefonszám megadása kötelező.': 'Phone number is required.',
  'Érvényes magyar telefonszámot adj meg (pl. +36 20 123 4567 vagy 06201234567).': 'Please enter a valid Hungarian phone number (e.g. +36 20 123 4567 or 06201234567).',
  'Érvényes telefonszámot adj meg nemzetközi formátumban (pl. +40 712 345 678).': 'Please enter a valid phone number in international format (e.g. +40 712 345 678).',
  'Születési év megadása kötelező.': 'Birth year is required.',
  'Érvényes születési évet adj meg (1960–2015).': 'Please enter a valid birth year (1960–2015).',
  'Nem megadása kötelező.': 'Gender is required.',
  'Nyelvi preferencia kiválasztása kötelező.': 'Language preference is required.',

  // Step 3: Főkategóriák és feliratok
  'Milyen területen keresel állást?': 'Professional field',
  'Milyen területen keresel állást?*': 'Professional field*',
  'Legalább egy területet kötelező megjelölni': 'At least one area must be marked',
  'Legalább egy területet kötelező megjelölni.': 'Please select at least one field.',
  'Legalább egy területet kötelező megjelölni. Lenyithatod a kategóriákat és azon belül kiválaszthatod a számodra releváns szakirányokat.': 'At least one area must be marked. You can expand the categories to select the fields relevant to you.',
  'terület kijelölve': 'field(s) selected',
  'Elsődleges érdeklődési területed': 'Primary field of interest',
  'Elsődleges érdeklődési területed*': 'Main professional field*',
  'Válaszd ki azt a főterületet, amelyen leginkább állást keresel.': 'Select the main field in which you are primarily looking for a job.',
  'Először jelölj ki legalább egy területet a fenti kategóriákból.': 'First select at least one field from the categories above.',
  'Elsődleges terület': 'Primary field',
  'Elsődleges terület megadása kötelező.': 'Please select your primary field of interest.',
  'Szakmai tapasztalat szintje': 'Level of work experience',
  'Szakmai tapasztalat szintje*': 'Level of work experience*',
  'Tapasztalati szint': 'Experience level',
  'Tapasztalati szint megadása kötelező.': 'Please select your experience level.',

  // Step 3: Főkategória címkék
  'Mérnöki, Műszaki': 'Engineering, Technical',
  'Mérnök, Műszaki területek': 'Engineering, Technical',
  'Mérnök, műszaki terület': 'Engineering, Technical',
  'IT, Digital Technology': 'IT, Digital Technology',
  'IT, Digital Technology területek': 'IT, Digital Technology',
  'Informatikai területek': 'IT, Digital Technology',
  'Informatikai terület': 'IT, Digital Technology',
  'Pénzügy, Számvitel, Beszerzés, Logisztika': 'Finance, Accounting, Procurement, Logistics',
  'Pénzügy, Számvitel, Beszerzés, Logisztika területek': 'Finance, Accounting, Procurement, Logistics',
  'Pénzügy, Számvitel, Logisztika területek': 'Finance, Accounting, Procurement, Logistics',
  'Pénzügy, Számvitel, Logisztika terület': 'Finance, Accounting, Procurement, Logistics',
  'Sales, Retail, Marketing, HR': 'Sales, Retail, Marketing, HR',
  'Sales, Retail, Marketing, HR területek': 'Sales, Retail, Marketing, HR',
  'Kereskedelem/Értékesítés, Marketing, HR területek': 'Sales, Retail, Marketing, HR',
  'Kereskedelem/Értékesítés, Marketing, HR terület': 'Sales, Retail, Marketing, HR',
  'Adminisztráció, Ügyfélszolgálat': 'Administration, Customer Service',
  'Adminisztráció, Ügyfélszolgálat területek': 'Administration, Customer Service',
  'Adminisztráció, Ügyfélszolgálat terület': 'Administration, Customer Service',
  'Szakirányú végzettséget igénylő területek': 'Other Fields Requiring Specialized Qualifications',
  'Szakirányú végzettséget igénylő további területek': 'Other Fields Requiring Specialized Qualifications',
  'Szakirányú végzettséget igénylő további terület': 'Other Fields Requiring Specialized Qualifications',

  // Step 3: Alcsoport fejlécek
  'PÉNZÜGY, SZÁMVITEL:': 'FINANCE, ACCOUNTING:',
  'BESZERZÉS, LOGISZTIKA, SUPPLY CHAIN:': 'PROCUREMENT, LOGISTICS, SUPPLY CHAIN:',
  'SALES, RETAIL:': 'SALES, RETAIL:',
  'MARKETING:': 'MARKETING:',
  'HR:': 'HR:',
  'EGÉSZSÉGÜGY, GYÓGYSZERIPAR:': 'HEALTHCARE, PHARMACEUTICAL INDUSTRY:',

  // Step 3: Tapasztalat opciók
  'Diákmunka, szakmai gyakorlat': 'Student work, internship',
  'Maximum 1 év tapasztalat': 'Up to 1 year experience',
  '2-3 év tapasztalat': '2-3 years of experience',
  '4-7 év tapasztalat': '4-7 years of experience',
  'Minimum 8 év tapasztalat': 'Minimum 8 years experience',

  // Step 3: Alkategóriák
  'Automatizálás, mechatronika, robotika': 'Automation, Mechatronics, Robotics',
  'Építész-, építőmérnök': 'Architecture, Civil Engineering',
  'Gépészmérnök': 'Mechanical Engineering',
  'Gyártás, termelés, folyamatfejlesztés': 'Manufacturing, Production, Process Development',
  'Környezet-, egészség-, munkavédelem (EHS)': 'Environment, Health and Safety (EHS)',
  'Közlekedés-, járműmérnök': 'Transportation, Vehicle Engineering',
  'Mérnök értékesítő': 'Sales Engineer',
  'Minőségbiztosítás': 'Quality Assurance',
  'Műszaki termékfejlesztés, tesztelés, K+F': 'Technical Product Development, Testing, R&D',
  'Vegyészmérnök, élelmiszeripari mérnök, biomérnök': 'Chemical Engineering, Food Engineering, Bioengineering',
  'Villamosmérnök, energetika': 'Electrical Engineering, Energy',
  'CAD tervező, Műszaki rajzoló': 'CAD Designer, Technical Draftsman',
  'Műszaki technikus': 'Technical Technician',
  'Műszaki projektmenedzser': 'Technical Project Manager',
  'Mérnök vezető': 'Engineering Manager',
  'További mérnöki állások': 'Other Engineering Jobs',
  'AI & Cybersecurity': 'AI & Cybersecurity',
  'AI, adattudomány, gépi tanulás': 'AI, Data Science, Machine Learning',
  'Cloud & Infrastructure, DevOps': 'Cloud & Infrastructure, DevOps',
  'Hardverfejlesztés & IoT': 'Hardware Development & IoT',
  'Hálózat, telekommunikáció': 'Network, Telecommunications',
  'Informatikai értékesítő': 'IT Sales Representative',
  'IT Business Analyst, IT Auditor, IT üzleti elemző': 'IT Business Analyst, IT Auditor',
  'IT Support, Helpdesk': 'IT Support, Helpdesk',
  'No-code developer': 'No-code Developer',
  'Rendszerintegrátor, rendszertervező, Scrum Master': 'System Integrator, System Designer, Scrum Master',
  'Szoftverfejlesztő és alkalmazáskészítő': 'Software Developer and Application Developer',
  'Tesztmérnök, tesztelő': 'Test Engineer, Tester',
  'Üzleti megoldások, vállalatirányítási rendszerek (ERP, SAP, CRM)': 'Business Solutions, Enterprise Resource Planning Systems (ERP, SAP, CRM)',
  'IT projektmenedzsment': 'IT Project Management',
  'Product Owner, CTO': 'Product Owner, CTO',
  'További informatikai állások': 'Other IT Jobs',
  'Accounting, Billing, Finance Support': 'Accounting, Billing, Finance Support',
  'Bank, biztosítás, befektetés': 'Banking, Insurance, Investment',
  'Kontrolling': 'Controlling',
  'Könyvelés': 'Bookkeeping',
  'Könyvvizsgáló, adótanácsadó': 'Auditor, Tax Advisor',
  'Pénzügy, számvitel, számlakezelés': 'Finance, Accounting, Invoice Management',
  'Pénzügyi / üzleti elemző, BI Analyst': 'Financial / Business Analyst, BI Analyst',
  'Risk & Treasury': 'Risk & Treasury',
  'Pénzügyi, számviteli vezető, projektmenedzsment': 'Finance and Accounting Manager, Project Management',
  'Beszerzés': 'Procurement',
  'Logisztika, szállítmányozás, fuvarszervezés, vámügyintézés': 'Logistics, Transportation, Freight Forwarding, Customs Administration',
  'Logistic Support': 'Logistic Support',
  'Raktározás, készletezés, Supply Chain': 'Warehousing, Inventory Management, Supply Chain',
  'Beszerzési, szállítmányozási, logisztikai vezető': 'Procurement, Transportation and Logistics Manager',
  'További gazdasági állások': 'Other Business Jobs',
  'Account Manager, termék-, szolgáltatásértékesítő': 'Account Manager, Product and Service Sales Representative',
  'Customer Success': 'Customer Success',
  'Inside Sales, Telefonos értékesítő': 'Inside Sales, Telesales Representative',
  'Sales Operations & Support': 'Sales Operations & Support',
  'Területi képviselő': 'Field Sales Representative',
  'Sales Manager': 'Sales Manager',
  'További sales állások': 'Other Sales Jobs',
  'Eladó, pénztáros, áruösszekészítő, raktáros': 'Seller, Cashier, Order Picker, Warehouse Worker',
  'Retail & Store Management': 'Retail & Store Management',
  'Brand & Product Management': 'Brand & Product Management',
  'Copywriting & Communications, PR': 'Copywriting & Communications, PR',
  'Design & Creative (UI/UX, Visual)': 'Design & Creative (UI/UX, Visual)',
  'Event & Community Management': 'Event & Community Management',
  'Marketing Analytics & Insights': 'Marketing Analytics & Insights',
  'Performance & PPC Marketing': 'Performance & PPC Marketing',
  'Social Media, Content & Influencer Marketing': 'Social Media, Content & Influencer Marketing',
  'Marketing (Project) Manager & Coordinator': 'Marketing (Project) Manager & Coordinator',
  'További marketing állások': 'Other Marketing Jobs',
  'Employer Branding & Culture': 'Employer Branding & Culture',
  'HR Operations & Payroll': 'HR Operations & Payroll',
  'HR Support': 'HR Support',
  'Recruitment & Talent Acquisition': 'Recruitment & Talent Acquisition',
  'HR Generalist, HR Manager': 'HR Generalist, HR Manager',
  'További HR állások': 'Other HR jobs',
  'Adminisztráció, adatrögzítés': 'Administration, Data Entry',
  'Irodavezetés, back office': 'Office Management, Back Office',
  'Recepció': 'Reception',
  'Online ügyfélszolgálat': 'Online Customer Service',
  'Személyes ügyfélszolgálat': 'In-person Customer Service',
  'Személyi, szakmai, projektasszisztens': 'Personal, Professional and Project Assistant',
  'Telefonos ügyfélszolgálat, Call Center operátor': 'Telephone Customer Service, Call Center Operator',
  'Vevőszolgálat': 'Customer Support',
  'Ügyfélszolgálati vezető, csoportvezető': 'Customer Service Manager, Team Leader',
  'További admin, ügyfélszolgálati állások': 'Other Administration and Customer Service Jobs',
  'Ápoló, szakápoló, betegszállító': 'Nurse, Specialist Nurse, Patient Transporter',
  'Egészségügyi technikus, (szak)asszisztens, laboráns': 'Healthcare Technician, Medical Assistant, Laboratory Assistant',
  'Gyógyszeripari kutató, fejlesztő': 'Pharmaceutical Researcher, Developer',
  'Orvos- és patikalátogató': 'Medical and Pharmacy Representative',
  'Orvos, szakorvos, gyógyszerész': 'Doctor, Specialist Doctor, Pharmacist',
  'Államigazgatás, közigazgatás, pályázatírás': 'Public Administration, Government Administration, Tender Writing',
  'Fordítás, tolmácsolás': 'Translation, Interpreting',
  'Jogtudományok': 'Legal Studies',
  'Képzés, oktatás, coaching': 'Training, Education, Coaching',
  'Természet- és élettudományok': 'Natural and Life Sciences',
  'Éttermi vendéglátás': 'Restaurant Hospitality',
  'Turizmus, idegenforgalom': 'Tourism, Travel and Hospitality',
  'Anyagmozgatás, rakodás': 'Material Handling, Loading',
  'Gépjárművezető, sofőr, futár': 'Vehicle Driver, Chauffeur, Courier',
  'További, felsőfokú végzettséget igénylő állások': 'Other Jobs Requiring Higher Education',
  'További, középfokú végzettséget igénylő állások': 'Other Jobs Requiring Secondary Education',

  // Siker oldal és hibaüzenetek
  'Sikeres regisztráció!': 'Registration successful!',
  'Köszönjük a regisztrációt! E-mailben elküldtük az aktiváló hivatkozást. Kérjük, ellenőrizd a fiókodat és kattints az aktiváló linkre a belépéshez.': 'Thank you for registering! We have sent the activation link to your email. Please check your inbox and click the link to activate your account.',
  'Az aktiválás után a megadott e-mail címeddel és jelszavaddal tudsz majd bejelentkezni.': 'After activation, you will be able to log in with your email address and password.',
  'Ez az e-mail cím már foglalt.': 'This email address is already taken.',
  'Ez az e-mail cím már regisztrált.': 'This email address is already registered.',
  'Ez az e-mail cím már regisztrált. Ha elfelejtette jelszavát, <a href="/wp-login.php?action=lostpassword">itt kérheti az újat</a>.': 'This email address is already registered. If you forgot your password, <a href="/wp-login.php?action=lostpassword">you can request a new one here</a>.',
  'Hálózati hiba. Kérjük, próbáld újra.': 'Network error. Please try again.',
  'Hiba történt a regisztráció során. Kérjük, próbáld újra.': 'An error occurred during registration. Please try again.',
  'Hálózati hiba. Kérjük, ellenőrizd az internetkapcsolatodat és próbáld újra.': 'Network error. Please check your internet connection and try again.',
  'Érvénytelen kérés.': 'Invalid request.',
  'Érvénytelen e-mail cím.': 'Invalid email address.',
  'A jelszó túl rövid.': 'The password is too short.',
  'Hiányzó kötelező adatok (név).': 'Missing required information (name).',
  'Érvénytelen telefonszám formátum.': 'Invalid phone number format.',
  'Érvénytelen születési év (1960–2015).': 'Invalid birth year (1960–2015).',
  'Túl sok regisztrációs kísérlet. Kérjük, próbáld újra 10 perc múlva.': 'Too many registration attempts. Please try again in 10 minutes.',
  'reCAPTCHA ellenőrzés sikertelen. Kérjük, próbáld újra.': 'reCAPTCHA verification failed. Please try again.',
};

const getApiSettings = () => {
  return (window as any).registrationApiSettings || { lang: 'hu', translations: {} };
};

export const getLang = (): 'hu' | 'en' => {
  const settings = getApiSettings();
  if (settings.lang === 'en') {
    return 'en';
  }
  // Fallback a böngésző vagy oldal nyelvére
  if (document.documentElement.lang?.startsWith('en')) {
    return 'en';
  }
  return 'hu';
};

const lookupTranslation = (dict: Record<string, string>, text: string): string | null => {
  if (!dict) return null;

  // 1. Közvetlen egyezés
  if (dict[text]) {
    return dict[text];
  }

  const lowerText = text.toLowerCase();

  // 2. Keresés tag-ekkel lefedett kulcsok között (pl. "> Szöveg<" vagy ">Szöveg<") - kis/nagybetű függetlenül
  const keyWithSpaceLower = `> ${lowerText}<`;
  const keyWithoutSpaceLower = `>${lowerText}<`;

  for (const k of Object.keys(dict)) {
    const kLower = k.toLowerCase();
    if (kLower === lowerText) {
      return dict[k];
    }
    if (kLower === keyWithSpaceLower || kLower === keyWithoutSpaceLower) {
      return dict[k].replace(/[><]/g, '').trim();
    }
  }

  // 3. Részleges egyezés és tisztítás egyéb esetekre - kis/nagybetű függetlenül
  for (const k of Object.keys(dict)) {
    const cleanKLower = k.replace(/[><]/g, '').trim().toLowerCase();
    if (cleanKLower === lowerText) {
      return dict[k].replace(/[><]/g, '').trim();
    }
  }

  return null;
};

export const t = (text: string): string => {
  const currentLang = getLang();
  
  if (currentLang !== 'en') {
    return text;
  }

  const settings = getApiSettings();
  const serverTranslations = settings.translations || {};

  // 1. Keresés a szerver oldali szótárban
  const serverMatch = lookupTranslation(serverTranslations, text);
  if (serverMatch) {
    return serverMatch;
  }

  // 2. Keresés a beépített szótárban
  const builtinMatch = lookupTranslation(BUILTIN_EN_TRANSLATIONS, text);
  if (builtinMatch) {
    return builtinMatch;
  }

  return text;
};
